import API from './base';

class InsuranceAPI extends API {
  sendInsuranceRequest(payload) {
    return this.post('/api/web/v1/insurance_requests', payload);
  }
}

export default new InsuranceAPI();
